import CasesList from './CasesList';
import { connect } from 'react-redux';
import * as AuthModule from 'Modules/AuthModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import { RootState } from 'Store/Reducers/RootReducer';
import { Selectors as AuthSelectors } from 'Modules/AuthModule';
import { Selectors as ViewManagementSelectors } from 'Modules/ViewManagementModule';
import { getCaseCounts, getCasesList, getClientCasesList, getClientCaseCounts, manageFavourite } from 'Store/Actions/cases';
import { getClientCaseXlsx } from 'Store/Actions/cases';
import * as CaseSelector from 'Store/Selectors/CaseSelector';

type ConnectedP = {
  isMenuExpanded: boolean;
  isAddReminderView: boolean;
  authorizedUser: AuthModule.Types.AuthorizedUserData;
  prevPath: string;
  caseCounts: any;
  casesList: any;
};
type DispatchedP = {
  expandMenu: () => void;
  getCaseCounts: (execType: string) => void;
  getCasesList: (execType: string, params: any) => void;
  getClientCasesList: (id: number, params: any) => void;
  getClientCaseCounts: (id: number) => void;
  showConfirmPopup: (typeConfirmPopup: string, dataToEdit: any) => void;
  manageFavourite: (caseId: number, isFavourite: boolean) => void;
  getClientCaseXlsx: (clientId: number, params) => void;
};

export type MainType = DispatchedP & ConnectedP;

const mapDispatchToProps: DispatchedP = {
  expandMenu: () => ViewManagementModule.Actions.expandMenu(),
  getCaseCounts: (execType) => getCaseCounts(execType),
  getCasesList: (execType, params) => getCasesList(execType, params),
  getClientCasesList: (id, params) => getClientCasesList(id, params),
  getClientCaseCounts: (id) => getClientCaseCounts(id),
  showConfirmPopup: (typeConfirmPopup: string, dataToEdit: any) => ViewManagementModule.Actions.showConfirmPopup(typeConfirmPopup, dataToEdit),
  manageFavourite: (caseId: number, isFavourite: boolean) => manageFavourite(caseId, isFavourite),
  getClientCaseXlsx: (clientId, params) => getClientCaseXlsx(clientId, params),
};

function mapStateToProps(state: RootState): ConnectedP {
  return {
    isMenuExpanded: ViewManagementSelectors.isMenuExpanded(state),
    isAddReminderView: ViewManagementSelectors.isAddReminderView(state),
    prevPath: ViewManagementSelectors.prevPath(state),
    caseCounts: CaseSelector.getCasesCounts(state),
    casesList: CaseSelector.getCasesList(state),
    authorizedUser: AuthSelectors.authorizedUser(state),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CasesList);
